module.exports = __webpack_public_path__ + "img/banner2.dbc1329c.png";